export enum CalculationState {
  NotStarted,
  Processing,
  Cancelled,
  Finished
}
